<template>
<div class="chapter">
<div class="inner_page">
<h4 class="h4-a">A<span class="smallcaps">CKNOWLEDGEMENTS</span></h4>
<p class="bodytext-center"><i>There is certainly no pleasure in idleness.</i></p>
<p class="normala"><span class="dropcap">W</span>riting a book of this nature is most definitely not a solitary pursuit. Long hours spent hunched over the computer, oblivious to everything except the gradually unfolding story appearing on the monitor, tend to take a toll on the author. Without the generous support and understanding of family, friends and co-workers, the task would be nearly incomprehensible.</p>
<p class="bodytext">With this in mind, I’d like to thank all those who contributed time, information, anecdotes, photos, memorabilia or moral support during this project. If I’ve missed anyone, please know I haven’t forgotten your contribution, even if I have neglected to include your name here. Thanks to Jim McKay, Gloria Evenson and all the members of Field’s Fans Chicago for everything you’ve provided, not the least of which have been friendship and support. Thanks to Susan Greene, Susan Pinto and Mike Russell, who were kind enough to share photos and remembrances, and to Shar Paul, Cathy Andorka, Lorena Lopez, Dan Sumiec and Barb Soberalski, who’ve always been in my corner.</p>
<p class="bodytext">And a special thanks goes to my ever-patient husband and live-in photography wiz, Peter Rimsa. Together, we make a great team.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_9781614230007_Acknowledgements.vue?d5562fc4